import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "product-list" }
const _hoisted_2 = { class: "row items-center justify-between q-mb-md" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "meta" }
const _hoisted_5 = {
  key: 0,
  class: "product-grid q-mb-md products-skeleton"
}
const _hoisted_6 = {
  class: "products-skeleton--item",
  style: {"opacity":".4"}
}
const _hoisted_7 = { class: "inner" }
const _hoisted_8 = {
  key: 1,
  class: "product-grid q-mb-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_product_card = _resolveComponent("product-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_pagination, {
          "model-value": _ctx.page || 1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:page', $event))),
          max: (_ctx.productTotal / (_ctx.pageSize || 1))+1,
          input: "",
          "direction-links": "",
          unelevated: ""
        }, null, 8, ["model-value", "max"]),
        _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "card-title q-mr-sm" }, null, -1)),
        _createElementVNode("span", _hoisted_4, "— " + _toDisplayString(_ctx.productTotal) + " products", 1)
      ]),
      _createVNode(_component_q_btn, {
        class: "q-ml-md",
        unelevated: "",
        rounded: "",
        outline: "",
        onClick: _ctx.handleAddProduct
      }, {
        default: _withCtx(() => [
          _createVNode(_component_add_icon, { left: "" }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Product", -1))
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (s) => {
            return _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_q_skeleton, { type: "rect" }),
                _createVNode(_component_q_skeleton, { type: "text" })
              ])
            ])
          }), 64))
        ]))
      : (_ctx.paginatedProducts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedProducts, (product) => {
              return (_openBlock(), _createBlock(_component_product_card, {
                product: product,
                key: product.sys.id,
                onClick: ($event: any) => (_ctx.productRoute(product.sys.id))
              }, null, 8, ["product", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
  ]))
}